import cx from 'classnames';
import type { PropsWithChildren } from 'react';

import Menu from './Menu';

type Props = PropsWithChildren<{
  subscriberId?: string;
  hasPreferencesEnabled?: boolean;
  isLoggedIn?: boolean;
}>;

const Container = ({ subscriberId, children, hasPreferencesEnabled = false, isLoggedIn }: Props) => (
  <div className="mx-auto mb-40 flex max-w-3xl flex-col items-start justify-between gap-8 px-4 py-8 sm:mb-0 lg:max-w-5xl lg:flex-row lg:items-start lg:justify-start xl:max-w-6xl xl:px-0 xl:pl-4">
    {isLoggedIn && subscriberId && (
      <div className="w-full max-w-2xl lg:w-60">
        <Menu hasPreferencesEnabled={hasPreferencesEnabled} subscriberId={subscriberId} />
      </div>
    )}

    <div className={cx('flex w-full flex-col space-y-12 lg:flex-1', !isLoggedIn && 'items-center')}>{children}</div>
  </div>
);

export default Container;
